import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import { formatMoney, formatNumber } from '../../common/helpers';
import useFetch from '../../common/useFetch';
import useInterval from '../../common/useInterval';
import { PrizeDistributorTypes } from '../../domain/Models';
import PrizeDistributionService from '../../domain/PrizeDistributionService';
import PrizeDistributorService from '../../domain/PrizeDistributorService';
import gs from '../../styles/style';
import { UserContext } from '../Auth/UserProvider';
import Breadcrumbs from '../Common/Breadcrumbs';
import { Pager, TableLoader, useDataframe } from '../Common/Dataframe';
import DateTime from '../Common/DateTime';
import Loader from '../Common/Loader';
import { ConfirmationModal, useModal } from '../Common/Modal';
var FontAwesomeIcon = require('@fortawesome/react-fontawesome').FontAwesomeIcon;
var PrizeDistributor = function (_a) {
    var _b;
    var match = _a.match;
    var t = useTranslation()[0];
    var user = useContext(UserContext).user;
    var _c = useFetch(function (config) { return PrizeDistributorService.getPrizeDistributor(match.params.prizeDistributor, config); }), prizeDistributor = _c.data, getPrizeDistributor = _c.get, setPrizeDistributor = _c.setData;
    useEffect(function () {
        getPrizeDistributor();
    }, []);
    var _d = useFetch(function (config) { return PrizeDistributorService.distribute(prizeDistributor, config); }, {
        onSuccess: setPrizeDistributor
    }), distribute = _d.post, distributing = _d.loading;
    var distributeModal = useModal({
        onClose: function (confirm) {
            if (confirm) {
                distribute();
            }
        }
    });
    useInterval(function () {
        getPrizeDistributor();
    }, prizeDistributor && prizeDistributor.distributing ? 3000 : null);
    if (!prizeDistributor) {
        return React.createElement(Loader, null);
    }
    var distributorComponents = (_b = {},
        _b[PrizeDistributorTypes.Credit] = CreditDistributor,
        _b[PrizeDistributorTypes.CreditMultiplier] = CreditDistributor,
        _b[PrizeDistributorTypes.Ticket] = TicketDistributor,
        _b);
    var DistributorComponent = distributorComponents[prizeDistributor.driver];
    return React.createElement(React.Fragment, null,
        React.createElement(Breadcrumbs, null,
            React.createElement(Link, { to: "/prize-distributors" }, t('prize_distribution'))),
        React.createElement("div", { className: gs('section-header') },
            React.createElement("h1", { className: gs('section-title') }, prizeDistributor.title),
            user.isManager() && React.createElement("div", { className: gs('section-options') },
                distributing || prizeDistributor.distributing ? React.createElement("span", { className: gs('mr-3') },
                    React.createElement(Loader, null)) : null,
                React.createElement("button", { type: "button", onClick: function () { return distributeModal.open(); }, disabled: distributing || prizeDistributor.distributing || !prizeDistributor.distributable, className: gs('btn', 'btn-primary') }, t('distribute')))),
        React.createElement(DistributorComponent, { prizeDistributor: prizeDistributor, key: prizeDistributor.last_distributed_at }),
        React.createElement(ConfirmationModal, { modal: distributeModal },
            React.createElement("h5", { className: gs('my-2') }, t('confirm_distribute', { count: prizeDistributor.distributable_count, title: prizeDistributor.title }))));
};
var CreditDistributor = function (_a) {
    var prizeDistributor = _a.prizeDistributor;
    var t = useTranslation()[0];
    var user = useContext(UserContext).user;
    var dataframe = useDataframe(function (config) {
        config.params = config.params || {};
        config.params.prize_distributor = prizeDistributor.id;
        return PrizeDistributionService.getPrizeDistributions(config);
    }, {
        perPage: 10
    });
    return React.createElement(React.Fragment, null,
        React.createElement("div", { className: gs('row') },
            React.createElement("div", { className: gs('col-md-3') },
                React.createElement("h3", null, formatNumber(prizeDistributor.distributable_count)),
                t('distributable_prizes')),
            React.createElement("div", { className: gs('col-md-3') },
                React.createElement("h3", null, formatMoney(prizeDistributor.distributable_amount)),
                t('distributable_amount'))),
        React.createElement("hr", { className: gs('my-4') }),
        React.createElement("h3", null, t('credit_transfer_files')),
        React.createElement("table", { className: gs('table-overview', 'mt-4', { loading: dataframe.isLoading() }) },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", { style: { width: '30%' } }, t('created_at')),
                    React.createElement("th", { style: { width: '15%' } }, t('prizes')),
                    React.createElement("th", { style: { width: '15%' } }, t('net_amount')),
                    React.createElement("th", { style: { width: '15%' } }, t('tax_amount')),
                    React.createElement("th", { style: { width: '10%' } }, t('password')),
                    (user.isManager() || user.isFinance()) && React.createElement("th", { style: { width: '15%' } }))),
            React.createElement("tbody", null,
                React.createElement(TableLoader, { dataframe: dataframe, columns: user.isManager() || user.isFinance() ? 5 : 4 }),
                dataframe.getData().map(function (prizeDistribution) { return React.createElement("tr", { key: prizeDistribution.id },
                    React.createElement("td", null,
                        React.createElement(Link, { to: "/prize-distributors/".concat(prizeDistributor.id, "/prize-distributions/").concat(prizeDistribution.id) },
                            React.createElement("strong", null,
                                React.createElement(DateTime, { date: prizeDistribution.created_at })))),
                    React.createElement("td", null, formatNumber(prizeDistribution.won_prizes_count)),
                    React.createElement("td", null, formatMoney(prizeDistribution.distribution.net_amount)),
                    React.createElement("td", null, formatMoney(prizeDistribution.distribution.tax_amount)),
                    React.createElement("td", null, prizeDistribution.distribution.password),
                    (user.isManager() || user.isFinance()) && React.createElement("td", { className: gs('text-right') },
                        React.createElement("a", { href: "/api/credit_distributions/".concat(prizeDistribution.distribution.id, "/download"), className: gs('btn', 'btn-outline-secondary', 'btn-sm'), download: true },
                            React.createElement(FontAwesomeIcon, { icon: "download" }),
                            ' ',
                            t('download')))); }))),
        dataframe.getPageCount() > 1 && React.createElement("div", { className: gs('mt-4') },
            React.createElement(Pager, { dataframe: dataframe })));
};
var TicketDistributor = function (_a) {
    var prizeDistributor = _a.prizeDistributor;
    var t = useTranslation()[0];
    var dataframe = useDataframe(function (config) {
        config.params = config.params || {};
        config.params.prize_distributor = prizeDistributor.id;
        return PrizeDistributionService.getPrizeDistributions(config);
    }, {
        perPage: 10
    });
    return React.createElement(React.Fragment, null,
        React.createElement("div", { className: gs('row') },
            React.createElement("div", { className: gs('col-md-3') },
                React.createElement("h3", null, formatNumber(prizeDistributor.distributable_count)),
                t('distributable_prizes'))),
        React.createElement("table", { className: gs('table-overview', 'mt-4', { loading: dataframe.isLoading() }) },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", { style: { width: '40%' } }, t('created_at')),
                    React.createElement("th", { style: { width: '60%' } }, t('distributed_tickets')))),
            React.createElement("tbody", null,
                React.createElement(TableLoader, { dataframe: dataframe, columns: 2 }),
                dataframe.getData().map(function (prizeDistribution) { return React.createElement("tr", { key: prizeDistribution.id },
                    React.createElement("td", null,
                        React.createElement(Link, { to: "/prize-distributors/".concat(prizeDistributor.id, "/prize-distributions/").concat(prizeDistribution.id) },
                            React.createElement("strong", null,
                                React.createElement(DateTime, { date: prizeDistribution.created_at })))),
                    React.createElement("td", null, formatNumber(prizeDistribution.won_prizes_count * prizeDistribution.distribution.quantity))); }))),
        dataframe.getPageCount() > 1 && React.createElement("div", { className: gs('mt-4') },
            React.createElement(Pager, { dataframe: dataframe })));
};
export default withRouter(PrizeDistributor);
